import ChannelFormVideos from './ChannelFormVideos'

export default ChannelFormVideos
